__turbopack_context__.v({
  "container": "SocialButton-module-scss-module__C3sULG__container",
  "root": "SocialButton-module-scss-module__C3sULG__root",
});
